import React, { useEffect, useRef } from "react";
import maplibregl from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";
import "./Kontakt.css";
import caminoLogo from "../Logos/Camino.webp";
import { useTranslation } from "react-i18next";
import AnimatedBackground from "../Layout/AnimatedBackground";

const initialCenter = [15.189719, 46.2676312];

const mapBounds = [
  [15.10, 46.22], 
  [15.27, 46.31], 
];

const Kontakt = () => {
  const { t } = useTranslation();
  const mapContainer = useRef(null);
  const map = useRef(null);

  useEffect(() => {
    if (mapContainer.current && !map.current) {
      map.current = new maplibregl.Map({
        container: mapContainer.current,
        style: {
          version: 8,
          sources: {
            osm: {
              type: "raster",
              tiles: [
                "https://a.tile.openstreetmap.org/{z}/{x}/{y}.png",
                "https://b.tile.openstreetmap.org/{z}/{x}/{y}.png",
                "https://c.tile.openstreetmap.org/{z}/{x}/{y}.png",
              ],
              tileSize: 256,
              attribution: "© OpenStreetMap contributors",
            },
          },
          layers: [
            {
              id: "osm",
              type: "raster",
              source: "osm",
            },
          ],
        },
        center: initialCenter,
        zoom: 13,
        pitch: 60,
        bearing: -17.6,
        maxBounds: mapBounds, 
      });

      map.current.scrollZoom.disable();

      const navControl = new maplibregl.NavigationControl({
        showCompass: false,
      });
      map.current.addControl(navControl, "top-right");

      const markerElement = document.createElement("div");
      markerElement.className = "kontakt-marker-icon";

      const marker = new maplibregl.Marker({
        element: markerElement,
        anchor: "bottom",
      })
        .setLngLat(initialCenter)
        .addTo(map.current);

      map.current.on("click", (e) => {
        const lng = e.lngLat.lng.toFixed(5);
        const lat = e.lngLat.lat.toFixed(5);

        marker
          .setLngLat([lng, lat])
          .setPopup(
            new maplibregl.Popup({ offset: 25 }).setHTML(`
              <div style="text-align: center;">
                <h3 style="margin: 0; color: #17458f;">Clicked Location</h3>
                <img src="${caminoLogo}" alt="Clicked Location" style="width: 150px; height: auto; margin: 5px 0; border-radius: 8px;">
                <p style="margin: 5px 0;">Latitude: ${lat}, Longitude: ${lng}</p>
                <a href="https://www.google.com/maps/search/?api=1&query=${lat},${lng}"
                  target="_blank"
                  style="text-decoration: none; color: #f7a81b;">
                  Open in Google Maps
                </a>
              </div>
            `)
          )
          .addTo(map.current);
      });
    }

    return () => {
      if (map.current) {
        map.current.remove();
        map.current = null;
      }
    };
  }, []);

  return (
    <AnimatedBackground>
      <section className="kontakt-container">
        <div className="kontakt-inner">
          <div className="kontakt-left">
            <div ref={mapContainer} className="kontakt-map" />
          </div>

          <div className="kontakt-right">
            <div className="kontakt-card">
              <img
                src={caminoLogo}
                alt="Restavracija Camino"
                className="kontakt-logo"
              />
              <div className="kontakt-text-block">
                <p className="kontakt-line">{t("club_email")}</p>
                <p className="kontakt-line">{t("club_founded")}</p>
                <p className="kontakt-line">• TRR: SI56 0400 1004 8731 043</p>
                <p className="kontakt-line">{t("club_meeting_location")}</p>
                <p className="kontakt-line">{t("club_meeting_time")}</p>
              </div>

              <div className="kontakt-bottom-logo-wrapper">
                <img
                src={process.env.PUBLIC_URL + "/Slike/Rotary.png"}
                alt="Camino logo"
                className="kontakt-bottom-logo"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </AnimatedBackground>
  );
};

export default Kontakt;
